const BASE_64_SLICE_STRING = 'base64,';

const getImageExtension = (base64: string): string =>
  base64.split(';')[0].split(':')[1];

export const convertFileToBase64 = (
  file: File,
): Promise<{
  base64String: string;
  fileType: string;
}> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (): void => {
      const fullBase64String = `${fileReader.result}`;
      const sliceIndex =
        fullBase64String.indexOf(BASE_64_SLICE_STRING) +
        BASE_64_SLICE_STRING.length;
      resolve({
        base64String: fullBase64String.slice(sliceIndex),
        fileType: getImageExtension(fullBase64String),
      });
    };
    fileReader.onerror = (error): void => {
      reject(error);
    };
  });
};
